import type { DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

export const DarkNeoChainTheme: DefaultTheme = mapDarkTheme(darkColors, {
  name: 'DarkNeoChain',
  backgroundBody: '#363636',
});
